/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Attach_Type_PropertyInputs */

const cs_chat_attach_type_property = /** @type {(inputs: Chat_Attach_Type_PropertyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nemovitost`)
};

const en_chat_attach_type_property = /** @type {(inputs: Chat_Attach_Type_PropertyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Property`)
};

/**
* | output |
* | --- |
* | "Property" |
*
* @param {Chat_Attach_Type_PropertyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const chat_attach_type_property = /** @type {((inputs?: Chat_Attach_Type_PropertyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Attach_Type_PropertyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_attach_type_property(inputs)
	return cs_chat_attach_type_property(inputs)
});